import React from 'react';
import { Box, Chip, IconButton } from '@mui/material';
import CaretDown from '@mds/icons/CaretDown';
import SlidersHorizontal from '@mds/icons/SlidersHorizontal';

type MobileFilterTriggerBarProps = {
    selectedGroupLabel: string;
    onOpenGroup: () => void;
    onOpenSort: () => void;
};

const MobileFilterTriggerBar: React.FC<MobileFilterTriggerBarProps> = ({
    selectedGroupLabel,
    onOpenGroup,
    onOpenSort,
}) => {
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                width: '100%',
                gap: 1,
            }}
        >
            <Chip
                label={selectedGroupLabel}
                icon={<CaretDown fontSize="small" />}
                onClick={onOpenGroup}
            />
            <IconButton
                color="secondary"
                onClick={onOpenSort}
                aria-label="Sort and view"
            >
                <SlidersHorizontal fontSize="small" />
            </IconButton>
        </Box>
    );
};

export default MobileFilterTriggerBar;
